import {percentChance} from '../../../helpers/numbers-helper.js'

export function getMiss(action, combatantMap, currentCombatantStateChanges, combatantModels) {

    //Copy the changes.
    let changes = {
        ...currentCombatantStateChanges
    };

    //Bail out of accuracy roll if this action can't miss
    if (!action.canMiss) {
        return changes
    }

    const casterModel = combatantModels[combatantMap.casterId];
    const accuracyChance = casterModel.getTotalAccuracy(action); //number
    const didSucceed = percentChance( accuracyChance );

    //Add stuff to the changes
    if (!didSucceed) {
        //console.log(`missed with ${accuracyChance}% chance`)
        changes["didMiss"] = true;
    }

    return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/miss.js